module.exports = __webpack_public_path__ + "img/GGJSC1.95d702c5.jpg";